import { useCallback } from 'react';

import { TFunction } from 'Modules/core/i18n';
import { validators } from 'Modules/core/forms';

import { FormValues, InvestorType, Role } from './types';


export const useRateValueFormatter = (t: TFunction) => useCallback((rate: number) => {
    if (!Number.isFinite(rate))
        return undefined;
    const value = rate.toString().replace('.', ',');

    return t('rateFormatter', { value: rate >= 0 ? `+${value}` : value });
}, [t]);

export const COMPANY_INN_LENGTH = 10;
export const INDIVIDUAL_INN_LENGTH = 12;

export const needInnTypes: InvestorType[] = [InvestorType.UL, InvestorType.IP];

export const innValidatorsByRole = {
    [Role.INVESTOR]: (value, values: FormValues) => needInnTypes.includes(values?.investorType) &&
    validators.pipe(
        validators.requiredKey('requiredInn'),
        validators.is.inn,
        validators.length.equal(values?.investorType === InvestorType.IP
            ? INDIVIDUAL_INN_LENGTH : COMPANY_INN_LENGTH),
    )(value),
    [Role.ISSUER]: validators.pipe(
        validators.requiredKey('requiredInn'),
        validators.is.inn,
    ),
};
